module.exports = __webpack_public_path__ + "img/FGr_Beleuchtung_B.79abb6a4.svg";